import React, { memo, useContext } from 'react'
import PropTypes from 'prop-types'

import { Modal, Button } from '../../../components/common'
import { LanguageContext } from '../../../context/LanguageContext'

const LeaveConfirmationModal = ({ show, cancelAlertModal, leaveClickHandler, ...rest }) => {
    const { strings } = useContext(LanguageContext)

    if (!show) {
        return null
    }

    const header = (
        <Modal.Heading
            heading={strings.editPriorityLeaveChangesHeading}
            cancelModalHandler={cancelAlertModal}
        />
    )

    const content = <p className={'paragraph'}>{strings.editPriorityLeaveChangesMsg}</p>

    const actions = (
        <div>
            <Button color={'primary'} size={'lg'} className={'mr-3'} onClick={leaveClickHandler}>
                {strings.LEAVE}
            </Button>
            <Button size={'lg'} onClick={cancelAlertModal}>
                {strings.CANCEL}
            </Button>
        </div>
    )

    return (
        <Modal
            className={'leave-modal'}
            header={header}
            content={content}
            actions={actions}
            type={'alert'}
            {...rest}
        />
    )
}

LeaveConfirmationModal.propTypes = {
    show: PropTypes.bool,
    cancelAlertModal: PropTypes.func,
    leaveClickHandler: PropTypes.func,
}

export default memo(LeaveConfirmationModal)
